/**
 * useSpeedtestMonitor — Story 5.5 (Speedtests Ergebnis-Monitor, Passiv-Monitor)
 *
 * Holt die Monitor-Liste vom neuen Endpunkt
 * GET /api/v2/hotspots/speedtests (listApiV2HotspotsSpeedtestsMonitor):
 * eine Zeile je Hotspot des Users mit Speedtest-Bestand — Durchschnittswerte
 * über alle vorhandenen Speedtests plus Zeitstempel des letzten Tests.
 *
 * Dokumentierte Datenlücke (OpenAPI): der Mobile-Oracle-Report enthält
 * keinen Jitter-Wert, `avg_jitter_ms` ist daher immer null (deprecated) —
 * die Spalte wurde deshalb aus dem UI entfernt, siehe SpeedtestMonitorPage.
 */
import { useApi } from '../../lib/use-api'
import apiClient from '../../lib/api-client'
import type { components } from '@heliumtracker/api-types'

export type SpeedtestMonitorEntry =
  components['schemas']['HotspotSpeedtestMonitorEntry']

export type SpeedtestMonitorMeta = {
  current_page?: number
  total_pages?: number
  total_count?: number
  per_page?: number
  /** Rollierendes Aggregationsfenster in Tagen (siehe Backend SPEEDTEST_MONITOR_WINDOW_DAYS). */
  window_days?: number
}

type SpeedtestMonitorResponse = {
  data?: SpeedtestMonitorEntry[]
  meta?: SpeedtestMonitorMeta
}

type UseSpeedtestMonitorResult = {
  entries: SpeedtestMonitorEntry[] | undefined
  meta: SpeedtestMonitorMeta | undefined
  isLoading: boolean
  isError: boolean
  refetch: () => void
}

export function useSpeedtestMonitor(page = 1): UseSpeedtestMonitorResult {
  const query = useApi<SpeedtestMonitorResponse>(
    ['speedtest-monitor', page],
    () =>
      apiClient.GET('/api/v2/hotspots/speedtests', {
        params: { query: { page } },
      }),
  )

  return {
    entries: query.data?.data,
    meta: query.data?.meta,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => query.refetch(),
  }
}
